import Insights from "@mui/icons-material/Insights";

import { makeSvgIcon } from "./svg-icon";

export const InsightsIcon = makeSvgIcon(
  Insights,
  (theme) => theme.palette.grey[900],
);

export default InsightsIcon;
